import React from 'react';
import DocsSidebar from './DocsSidebar';
import { SheetLayout } from '@/ui/layout/SheetLayout';
import { SheetBadge } from '@/ui/layout/SheetBadge';
import { LandingHeader } from '@/features/landing/components/LandingHeader';

const DocsLayout: React.FC<{ children: React.ReactNode; rightSidebar?: React.ReactNode }> = ({ children, rightSidebar }) => {
  return (
    <SheetLayout>
      <LandingHeader />
      <div className="flex flex-col md:flex-row min-h-[calc(100vh-8rem)]">
        {/* Left Sidebar */}
        <div className="w-full md:w-72 shrink-0 border-b md:border-b-0 md:border-r border-neutral-950 dark:border-neutral-100 p-6 md:p-8 bg-neutral-50 dark:bg-neutral-900/10 flex flex-col gap-12 sticky top-0 h-fit max-h-screen overflow-y-auto">
          <div>
            <SheetBadge className="mb-6">INDEX</SheetBadge>
            <div className="mb-6">
                <a href="/" className="font-mono text-sm font-bold uppercase hover:underline decoration-2 underline-offset-4 flex items-center gap-2">
                    ← Back to App
                </a>
            </div>
            <DocsSidebar tableOfContents={rightSidebar} />
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1 p-6 md:p-12 flex justify-center bg-background">
          <div className="max-w-3xl w-full">
             {children}
          </div>
        </main>
      </div>
    </SheetLayout>
  );
};

export default DocsLayout;
